module.exports = __webpack_public_path__ + "static/media/Thumbnail.e3c54b1c.jpg";